import {isNilOrEmpty} from 'ramda-adjunct';

import {
  useGetServiceCaseOrderVariantsQuery,
  useGetServiceOrderIntegrationsQuery,
  useGetServiceOrderQuery,
  useGetServiceOrderVariantQuery,
} from '@dms/api/workshop';

interface UseOrderCardDataParams {
  serviceCaseId: string;
  serviceOrderId: string;
  isExpanded: boolean;
}

export const useOrderCardData = (params: UseOrderCardDataParams) => {
  const serviceOrderResult = useGetServiceOrderQuery({
    serviceCaseId: params.serviceCaseId,
    serviceOrderId: params.serviceOrderId,
  });

  const serviceOrderVariantResult = useGetServiceOrderVariantQuery(
    {
      serviceOrderVariantId: serviceOrderResult.data?.serviceOrderVariantId ?? '',
    },
    {
      skip: !serviceOrderResult.data?.serviceOrderVariantId,
    }
  );

  const variantsResult = useGetServiceCaseOrderVariantsQuery({
    serviceCaseId: params.serviceCaseId,
  });

  const integrationsResult = useGetServiceOrderIntegrationsQuery(
    {
      serviceCaseId: params.serviceCaseId,
      serviceOrderId: params.serviceOrderId,
    },
    {
      skip:
        !params.isExpanded ||
        isNilOrEmpty(params.serviceCaseId) ||
        isNilOrEmpty(params.serviceOrderId),
    }
  );

  return {
    serviceOrder: serviceOrderResult.data,
    serviceOrderVariant: serviceOrderVariantResult.data,
    variants: variantsResult.data,
    integrations: integrationsResult.data,
    isLoading:
      serviceOrderResult.isLoading ||
      variantsResult.isLoading ||
      serviceOrderVariantResult.isLoading ||
      integrationsResult.isLoading,
    isError:
      serviceOrderResult.isError ||
      variantsResult.isError ||
      serviceOrderVariantResult.isError ||
      integrationsResult.isError,
  };
};
